<template>
    <div class="p-4">
        <b-form class='basic-form' @submit="submit" novalidate>
            <h1 class="mb-4">{{ $t('auth.signup') }}</h1>
            <b-form-group :label="$t('auth.name')">
                <b-form-input v-model="user.name" :state="states.name" type="text" placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.name' />
            </b-form-group>

            <b-form-group :label="$t('auth.email')">
                <b-form-input v-model="user.email" :state="states.email" type="email" placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.email' />
            </b-form-group>

            <b-form-group :label="$t('auth.password')">
                <b-form-input v-model="user.password" :state="states.password" :id="dynamicID()" type="password"
                    placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.password' />
            </b-form-group>

            <b-form-group :label="$t('auth.repeatPassword')">
                <b-form-input v-model="user.password_confirmation" :state="states.password_confirmation" :id="dynamicID()"
                    type="password" placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.password_confirmation' />
            </b-form-group>

            <b-form-group :label="$t('auth.workspaceName')">
                <b-form-input v-model="user.client_name" :state="states.client_name" type="text" placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.client_name' />
            </b-form-group>

            <b-form-group :label="$t('auth.workspaceLogo')">
                <b-form-file v-model="user.client_logo" @change="onFileChange" :state="states.client_logo" type="file">
                </b-form-file>
                <FormGroupError :errors='errors.client_logo' />
            </b-form-group>
            <div id="preview">
                <img v-if="previewUrl" :src="previewUrl" />
            </div>

            <b-form-group :label="$t('auth.workspaceSlug')">
                <b-form-input v-model="user.client_slug" :state="states.client_slug" type="text" placeholder="">
                </b-form-input>
                <FormGroupError :errors='errors.client_slug' />
            </b-form-group>

            <FormErrors :hasErrors='hasErrors' :errors='errors'></FormErrors>

            <div class="d-flex justify-content-between mt-4 mb-2">
                <button v-if='!this.saving' type="submit" class="btn btn-primary">{{ $t('auth.signup') }}</button>

                <b-button v-if='this.saving' variant="primary" :disabled='true'>
                    <b-spinner small type="grow"></b-spinner>
                    saving...
                </b-button>
                <locale-switcher />
            </div>

        </b-form>
    </div>
</template>

<script>
import BaseForm from '@/views/BaseForm'
export default {
    extends: BaseForm,
    data: function () {
        return {
            previewUrl: null,
            user: {
            }
        }
    },
    methods: {
        onFileChange(e) {
            const file = e.target.files[0];
            if (file) {
                this.previewUrl = URL.createObjectURL(file);
            } else {
                this.previewUrl = null;
            }
        },
        save: function (apiClient) {
            let userData = new FormData();
            Object.keys(this.user).forEach(key => userData.append(key, this.user[key]));
            apiClient.headers = {
                "Content-Type": "multipart/form-data"
            };
            return apiClient.post('signup', userData);
        },
        afterSave: function (response) {
            this.apiClient.setUser(response.user);
            this.apiClient.setToken(response.token);
            this.$router.push({ name: 'Main' });
            this.$emit('saved', 1);

        }
    }
}
</script>

<style>
#preview {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 100px;
}
</style>